// Auto generated file, do not manually modify!
// com.hotpads.cometdtos.brand.ZgBrand

export enum ZgBrand {
  HOTPADS = 'HOTPADS',
  TRULIA = 'TRULIA',
  ZILLOW = 'ZILLOW',
}

export const ZgBrand_values = [ZgBrand.HOTPADS, ZgBrand.TRULIA, ZgBrand.ZILLOW] as const;
